import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.188 4.388c.812-1.384 2.812-1.384 3.624 0l2.315 3.95a.6.6 0 1 1-1.035.607l-2.316-3.95a.9.9 0 0 0-1.552 0l-2.316 3.95a.6.6 0 0 1-1.035-.607l2.315-3.95Zm-4.072 8.134a.6.6 0 0 1 .214.821l-1.254 2.14a.9.9 0 0 0 .776 1.354h4.086a.6.6 0 1 1 0 1.2H5.852c-1.622 0-2.632-1.762-1.811-3.161l1.254-2.14a.6.6 0 0 1 .821-.214Zm11.768 0a.6.6 0 0 1 .821.214l1.254 2.14c.82 1.4-.189 3.162-1.811 3.162h-4.085a.6.6 0 0 1 0-1.2h4.085a.9.9 0 0 0 .776-1.356l-1.254-2.139a.6.6 0 0 1 .214-.821Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.367 8.981 8.7 12.941H12l-.367 2.64 3.667-3.96H12l.367-2.64Z",
      fill: "currentColor"
    })]
  }));
};
export default SvgComponent;